// extracted by mini-css-extract-plugin
module.exports = {"navbarBreakpoint":"1216px","navbar":"Navbar_navbar__W_ouQ","navbar-main":"Navbar_navbar-main__YNtwo"};